import { FC } from 'react';
import { Layout } from 'antd';

import styles from './styles.module.scss';

import { Logo } from '@/widgets/logo';

const { Header } = Layout;

export const UnauthorizedHeader: FC = () => {
    return (
        <Header className={styles['header']}>
            <Logo />
            <a href="#" className={styles['link']}>
                Help Center
            </a>
        </Header>
    );
};
